export default __webpack_public_path__ + "static/media/u2.95736d39.svg";